// extracted by mini-css-extract-plugin
module.exports = {"FancyCheckbox":"FancyCheckbox-nIJW1","Lever":"Lever-59-Z9","Checked":"Checked-1JO76"};